<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cfJvFS/tc-custom/9781460399859.jpg?1726871162654" alt="This image is the cover for the book Don't Say a Word"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Don't Say a Word
      </h1>
      <p class="bookDescription body article font2">
        <b>A former assassin turned FBI agent must protect a vulnerable beauty from a sadistic madman in this dark and sexy romantic thriller.</b><br/><br/>Groomed by a secret society of elite killers, Damon worked for the covert group until a mission went brutally wrong. He can’t forgive himself for the innocent woman who died, but he can seek justice for others as an FBI agent. And when his brother is arrested for murder, Damon is determined to clear his name.<br/><br/>Damon’s investigation leads to a severely injured “Jane Doe” who holds the key to the case, along with a darker terror—one that could expose his deadly secrets. Despite the danger, he’s drawn to the nameless beauty, igniting a passion that burns hot between them. But with a madman out to silence her forever, Damon knows he must deny their love. And to stop the man responsible, he must return to the dark shadows of a killer’s mind . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rita Herron
      </h2>
      
      <p class="authorDescription body article">Award-winning author Rita Herron wrote her first book when she was twelve, but didn&rsquo;t think real people grew up to be writers. Now she writes so she doesn&rsquo;t have to get a real job. A former kindergarten teacher and workshop leader, she traded storytelling to kids for writing romance. She lives in Georgia with her own romance hero. She loves to hear from readers, so please&#160;visit her website, www.ritaherron.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d485d36